import { motion } from "framer-motion";
import { ReactNode } from "react";

type DropdownFramerProps = {
  children: ReactNode; // Optional children prop
  isDropdownVisible: boolean;
  className?: string;
};

export default function DropdownFramer({
  children,
  isDropdownVisible,
  className,
}: DropdownFramerProps) {
  return (
    <motion.div
      className={className}
      animate={{ rotate: isDropdownVisible ? 180 : 0 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
}
